import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer>

      {/* UK National Terrorism Threat Level Banner */}
      <div className="threat-level-banner">
        <a
          href="https://www.mi5.gov.uk/threats-and-advice/terrorism-threat-levels"
          target="_blank"
          rel="noopener noreferrer"
          className="threat-level-link"
          aria-label="UK National Terrorism Threat Level - SEVERE - Click for more information from MI5"
        >
          <span className="threat-level-label">UK NATIONAL TERRORISM THREAT LEVEL:</span>
          <span className="threat-level-badge">SEVERE</span>
          <span className="threat-level-source">via MI5.gov.uk ↗</span>
        </a>
      </div>

      <div className="footer-container">
        <div className="footer-section footer-services">
          <h3>Our Services</h3>
          <div className="services-columns">
            <ul>
              <li><Link to="/service/0">Construction Site</Link></li>
              <li><Link to="/service/1">Building Site</Link></li>
              <li><Link to="/service/2">Solar Panel</Link></li>
            </ul>
            <ul>
              <li><Link to="/service/3">Retail Security</Link></li>
              <li><Link to="/service/4">Door Supervisor</Link></li>
              <li><Link to="/service/5">Corporate</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-section footer-policies">
          <h3>Legal &amp; Policies</h3>
          <ul>
            <li><Link to="/policy/public-protection">Public Protection Policy</Link></li>
            <li><Link to="/policy/data-protection">Data Protection Policy</Link></li>
            <li><Link to="/policy/social-media">Social Media Policy</Link></li>
            <li><Link to="/policy/business-continuity">Business Continuity Plan</Link></li>
            <li><Link to="/policy/mission">Our Mission</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
          </ul>
        </div>

        <div className="footer-section footer-contact">
          <h3>Contact Information</h3>
          <div className="contact-details">
            <p><strong>📞 Phone:</strong> <a href="tel:+447446084868">+44 7446 084868</a></p>
            <p><strong>📧 Email:</strong> <a href="mailto:info@observantsecurity.co.uk">info@observantsecurity.co.uk</a></p>
            <p><strong>📍 Address:</strong> Unit A9, Park Lane, Castle Vale, Birmingham, B35 6LJ</p>
          </div>

          {/* Accreditation logos — ICO, SafeContractor, Constructionline only */}
          <div className="footer-accreditations">
            <h4>Accreditations</h4>
            <div className="footer-accred-logos">
              <a
                href="https://ico.org.uk/ESDWebPages/Entry/ZB538133"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ICO Registration - Information Commissioner's Office"
                title="ICO Registered"
                className="footer-accred-text-badge"
              >
                ICO Registered
              </a>
              <a
                href="https://www.alcumus.com/safecontractor"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="SafeContractor Accreditation"
                title="SafeContractor Accreditation"
              >
                <img src="/license images/contracters_logo_2.png" alt="SafeContractor Accredited" loading="lazy" />
              </a>
              <a
                href="https://www.constructionline.co.uk/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Constructionline Member"
                title="Constructionline Member"
              >
                <img src="/license images/contracters_logo_3.png" alt="Constructionline Member" loading="lazy" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="social-links-centered">
          <a href="https://www.linkedin.com/company/observant-security-ltd/about/?viewAsMember=true" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <img src="/Socalmedia Icons/linkedin.png" alt="LinkedIn" className="social-icon-img" loading="lazy" />
          </a>
          <a href="https://wa.me/+447925127201" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <img src="/Socalmedia Icons/whattsup.png" alt="WhatsApp" className="social-icon-img" loading="lazy" />
          </a>
          <a href="https://www.instagram.com/observantsecurity" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <img src="/Socalmedia Icons/instagram.png" alt="Instagram" className="social-icon-img" loading="lazy" />
          </a>
        </div>

        <div className="copyright-bar">
          <p>
            &copy; {new Date().getFullYear()} Observant Security Limited. All Rights Reserved.
            {' '}| <Link to="/policy/data-protection">Privacy Policy</Link>
          </p>
          <p className="footer-legal-text">
            Company registered in England and Wales. Company No. 15182797. VAT Registration No. 503927888.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
